import React from 'react'
import { Button } from 'antd'
import { SettingOutlined } from '@ant-design/icons'

interface SettingsButtonProps {
  onClick: () => void
}

const SettingsButton: React.FC<SettingsButtonProps> = ({ onClick }) => {
  return (
    <Button
      type="text"
      icon={<SettingOutlined />}
      onClick={onClick}
      style={{
        border: 'none',
        background: 'transparent',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    />
  )
}

export default SettingsButton